import { api } from "../app/api.js";
import { store } from "../app/store.js";
import { display_errors } from "../helpers/forms.js";

export default {
    template: `
        <div class="background posters"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Forgotten Password</h1>
        
                <form id="forgotten-form" class="form">
                    <div class="input">
                        <label for="ForgottenEmailAddress">Email Address</label>
                        <input type="text" id="ForgottenEmailAddress" name="email" autocomplete="off"/>
                    </div>
        
                    <button id="ForgottenSubmit" type="submit">Reset</button>
                    <div id="ForgottenErrors" class="errors hidden"></div>
                </form>
                
                <div id="forgotten-complete" class="form hidden">
                    <p>We have emailed you a password reset link</p>
                </div>
            </div>
        </div>
    `,

    $form: null,
    $errors: null,
    $submit: null,

    submit (event) {
        event.preventDefault();

        this.$submit.disabled = true;
        this.$submit.textContent = 'Resetting...';
        this.$errors.textContent = '';
        this.$errors.classList.add('hidden');

        api.post({
            url: '/auth/forgotten',
            data: {
                email: this.$form.email.value,
            },
            success: () => {
                this.$form.classList.add('hidden');
                const $complete = document.getElementById('forgotten-complete');
                $complete.classList.remove('hidden');
            },
            error: (response) => {
                display_errors(this.$errors, response, this.$form);

                this.$submit.disabled = false;
                this.$submit.textContent = 'Reset';
            },
        });
    },
    _boundSubmit: null,

    onMount() {
        this.$form = document.getElementById('forgotten-form');
        this.$errors = document.getElementById('ForgottenErrors');
        this.$submit = document.getElementById('ForgottenSubmit');

        this._boundSubmit = this.submit.bind(this);
        this.$form.addEventListener('submit', this._boundSubmit);
    },

    onUnmount() {
        if (this._boundSubmit) this.$form.removeEventListener('submit', this._boundSubmit);
    },
}
